module.exports = __webpack_public_path__ + "static/media/CLIDEOffice.35444b94.png";